module.exports = __webpack_public_path__ + "static/media/bofa_icon_like.d02d468d.svg";